import './title.css'

const Title = ({text}) => {

      return (
            <div className="title_content">
                  <h2>{text}</h2>
            </div>
      )
}

export default Title
